module.exports = __webpack_public_path__ + "img/fondo-banner-principal.2cf225ce.png";